import { SVGProps } from 'react'

type BackwardArrowIconProps = SVGProps<SVGSVGElement>
const BackwardArrowIcon = ({ className, ...props }: BackwardArrowIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={21}
    fill="none"
    className={className}
    {...props}
  >
    <path
      fill="#fff"
      d="M0 10.5 12.85 0v5.706h3.146c11.407 0 13.636 8.452 11.014 14.66-.525-5.68-7.769-5.547-12.98-5.547h-1.18V21L0 10.5Z"
    />
  </svg>
)
export default BackwardArrowIcon
